// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"4806ee96","453":"eddecd06","455":"61bece6f"}[chunkId] + ".chunk.js";
};